export enum HTTPStatusCodeEnum {
  UNAUTHORIZED = 401,
  UNSUPPORTED_MEDIA_TYPE = 415
}
